export enum FundraisingDocumentType {
  PV_EXERCICE = 'PV_EXERCICE',
  PV_CONSTATATION = 'PV_CONSTATATION',
  SUBSCRIPTION = 'SUBSCRIPTION',
  IBAN = 'IBAN',
  SHAREHOLDER_AGREEMENT = 'SHAREHOLDER_AGREEMENT',
  OWNERSHIP_CERTIFICATE = 'OWNERSHIP_CERTIFICATE',
  PEA_PME_CERTIFICATE = 'PEA_PME_CERTIFICATE',
  PEA_CERTIFICATE = 'PEA_CERTIFICATE',
  IR_PME_CERTIFICATE = 'IR_PME_CERTIFICATE',
  CUSTOM_FILE = 'CUSTOM_FILE',
  FUNDS_SOURCE_CERTIFICATE = 'FUNDS_SOURCE_CERTIFICATE',
  MIFID = 'MIFID',
  RMT_EXTRACT = 'RMT_EXTRACT',
  DEPOSIT_CERTIFICATE = 'DEPOSIT_CERTIFICATE',
}
